// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"453081e6","367":"8066f14c","650":"1acc7d44","817":"e8406ef4"}[chunkId] + ".css";
};